"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
// MARK: Mobx
const mobx_1 = require("mobx");
const _1 = require(".");
class InfinityScrollShelf {
    constructor(getItems, options) {
        this._itemsPerPage = 20;
        this.loader = new _1.LoaderShelf();
        this.initialLoader = new _1.InitialLoaderShelf();
        this.fetchData = (newPage) => tslib_1.__awaiter(this, void 0, void 0, function* () {
            if (this.loader.isLoading) {
                return;
            }
            let hasToReplace = false;
            if (!newPage || newPage < 0) {
                newPage = 0;
                hasToReplace = true;
                this.hasNextPage = true;
            }
            try {
                this.loader.start();
                const possibleItems = yield this._getItems(newPage);
                if (possibleItems.length > 0) {
                    const newPageValue = newPage;
                    mobx_1.runInAction(() => {
                        this.page = newPageValue;
                        this.hasNextPage = (possibleItems.length === this.itemsPerPage);
                    });
                }
                else {
                    this.hasNextPage = false;
                }
                this.appendItems(possibleItems, hasToReplace);
            }
            catch (e) {
                mobx_1.runInAction(() => {
                    if (this.onError) {
                        this.onError(e);
                    }
                    this.fetchError = e;
                });
            }
            finally {
                this.initialLoader.done();
                this.loader.end();
            }
        });
        this.applyFilter = (filter) => {
            this.appendItems(this.listItems.filter(filter), true);
        };
        this.appendItems = (newItems, replace = false) => {
            if (replace) {
                this._items = newItems;
            }
            else {
                this._items = [
                    ...this._items,
                    ...newItems,
                ];
            }
        };
        this.prependItems = (newItems, replace = false) => {
            if (replace) {
                this._items = newItems;
            }
            else {
                this._items = [
                    ...newItems,
                    ...this._items,
                ];
            }
        };
        this.replaceItem = (itemId, newValue) => {
            if (this._items.length <= 0) {
                return;
            }
            let foundIndex = 0;
            const foundItem = this._items.find((item, index) => {
                if (item.id === itemId) {
                    foundIndex = index;
                    return true;
                }
                return false;
            });
            if (foundItem) {
                const leftList = this._items.filter((_, i) => i < foundIndex);
                const rightList = this._items.filter((_, i) => i > foundIndex);
                this._items = [...leftList, newValue, ...rightList];
            }
        };
        this.nextPage = () => tslib_1.__awaiter(this, void 0, void 0, function* () {
            if (this.hasNextPage) {
                yield this.fetchData(this.page + 1);
            }
        });
        this.previousPage = () => tslib_1.__awaiter(this, void 0, void 0, function* () {
            throw new Error("Previous Page don't exist on InfinityScrollShelf");
        });
        this.refreshItems = () => tslib_1.__awaiter(this, void 0, void 0, function* () {
            yield this.fetchData();
        });
        this.clear = () => {
            this.fetchError = null;
            this._items = [];
            this.page = 0;
        };
        this.page = 0;
        this.hasNextPage = true;
        this.fetchError = null;
        this._items = [];
        this._getItems = getItems;
        mobx_1.makeAutoObservable(this);
        if (options) {
            if (options.itemsPerPage) {
                this._itemsPerPage = options.itemsPerPage;
            }
            this.onError = options.onError;
        }
        if (options === null || options === void 0 ? void 0 : options.fetchOnConstructor) {
            this.fetchData();
        }
    }
    get itemsPerPage() {
        return this._itemsPerPage;
    }
    /**
     * @deprecated use items per page
     */
    get itemPerPage() {
        return this._itemsPerPage;
    }
    get listItems() {
        return this._items.slice();
    }
    get isLoading() {
        return this.loader.isLoading;
    }
    get listHasNextPage() {
        return this.hasNextPage;
    }
    get isEmpty() {
        return this._items.length === 0;
    }
    get didInitialLoading() {
        return this.initialLoader.isLoading;
    }
}
exports.default = InfinityScrollShelf;
